import FinancialSegmentsFields from "components/stocks/modern/fragments/FinancialSegmentsFields";
import gql from "graphql-tag";

export default gql`
  query FinancialGeographicSegments($tickerSymbol: TickerSymbol!) {
    financialGeographicSegments(tickerSymbol: $tickerSymbol) {
      ...FinancialSegmentsFields
    }
  }

  ${FinancialSegmentsFields}
`;
